import React, { useState, useEffect } from "react";
// Chakra imports
import {
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon,
  Popover,
  PopoverTrigger,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  PopoverContent,
  Divider,
} from "@chakra-ui/react";
import { FaList, FaPencilAlt, FaTrashAlt } from "react-icons/fa";
// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import TablesProjectRow from "components/Tables/TablesProjectRow";
import TablesTableRow from "components/Tables/TablesTableRow";
import { tablesProjectData, tablesTableData } from "variables/general";
import useGetCustomers from "../../hooks/useGetCustomers";
import CreateCustomer from "../../modals/CreateCustomer";
import EditCustomer from "../../modals/EditCustomer";
import Pagination from "../../views/Custom/Pagination";
import { MySearchBar } from "views/Custom/MySearchBar";
import OrderHistory from "modals/OrderHistory";
import { useAuth } from "contexts/auth";

function Customers() {


  const authUser = useAuth();
  const [ keyword, setKeyword ] = useState("");
  const [ plateNos, setPlateNos ] = useState("");
  const [ page, setPage ] = useState(1); 
  const pageLimit = 10;
  let {
    customers, 
    totalCustomers,
    setGettingCustomers, 
    gettingCustomers, 
    gettingCustomersReqSuccess 
  } = useGetCustomers({ 
    page, 
    limit: pageLimit,
    keyword: keyword, 
    plateKeyword: plateNos, 
  });
  const { isOpen: isOpenCreate, onOpen: onOpenCreate, onClose: onCloseCreate } = useDisclosure();
  const { isOpen: isOpenEdit, onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
  const { isOpen: isOpenHistory, onOpen: onOpenHistory, onClose: onCloseHistory } = useDisclosure();
  const [ toEditUser, setToEditUser ] = useState(null);

  useEffect(() => {
    reloadPage();
  }, [page]);

  useEffect(() => {
    if (parseInt(page) != 1) {
      setPage(1);
    } else {
      reloadPage();
    }
  }, [keyword, plateNos]);

  const reloadPage = () => {
    setGettingCustomers(true);
  }

  const selectEditItem = (id) => {
    const user = customers.find((c) => c.id === id);
    setToEditUser(user);
    onOpenEdit(true);
  }


  const selectHistoryItem = (id) => {
    const user = customers.find((c) => c.id === id);
    setToEditUser(user);
    onOpenHistory(true);
  }


  const textColor = useColorModeValue("gray.700", "white");

  return (
    <>
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader p="6px 0px 22px 0px">
          <Flex w="100%"
            flexDirection={{
              sm: "row",
              md: "row",
            }}
            alignItems={{ xl: "center" }}>
            <MySearchBar 
              keyword={keyword}
              setKeyword={setKeyword}
              onReload={reloadPage}
            />
            <Box marginLeft="8px"></Box>
            <MySearchBar 
              keyword={plateNos}
              setKeyword={setPlateNos}
              onReload={reloadPage}
              hint="By Car Make/Type/Plate"
            />
            <Spacer />
            <Box>
            {authUser.auth.role == 'manager'
              ? <Button colorScheme="teal" mr="4" onClick={onOpenCreate}>
                Create New
              </Button>
              : null}
            </Box>
          </Flex>
        </CardHeader>
        <CardBody>
          <Flex direction="column" w="100%">
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" p={2} color="gray.400">
                  <Th p={2} color="gray.400">Full Name</Th>
                  <Th p={2} color="gray.400">Mobile</Th>
                  <Th p={2} color="gray.400">Email</Th>
                  <Th p={2} color="gray.400">Company</Th>
                  <Th p={2} color="gray.400">Company Number</Th>
                  <Th p={2} color="gray.400">Recent Services</Th>
                  {authUser.auth.role == 'manager'
                  ? 
                  <Th p={2} color="gray.400">Status</Th>
                  : null}
                  <Th p={2} color="gray.400">Actions</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {gettingCustomers ? 
                  <Tr my=".8rem" >
                    <Td minWidth={{ sm: "250px" }} p={2} colSpan={4}>
                      <Progress isIndeterminate />
                    </Td>
                  </Tr>
                  : customers.map((user) => {
                    return (
                      <Tr my=".8rem" p={2} key={`customers-${user.id}`}>
                        <Td p={2}>{user.firstName + ' ' + user.lastName}</Td>
                        <Td  p={2}>{user.mobile ? user.mobile : ''}</Td>
                        <Td  p={2}>{user.email}</Td>
                        <Td  p={2}>{user.companyName}</Td>
                        <Td  p={2}>{user.companyNumber}</Td>
                        <Td  p={2}>{user.cars 
                          ? user.cars.map(c => { 
                            return <Popover>
                            <PopoverTrigger>
                              <Button variant="outline" mr="1">{c.carPlate}</Button>
                            </PopoverTrigger>
                            <PopoverContent>
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverHeader>Recent transactions/orders</PopoverHeader>
                              <PopoverBody>
                                {c.orders.map(o => {
                                  return <>
                                    <Flex direction="row">
                                    <Box fontStyle="initial" width="fit-content">{new Date(Date.parse(o.receiveDate)).toLocaleDateString()}</Box> - <Box fontWeight="bold"  width="fit-content"> {o.odometer} Odometer</Box>
                                    </Flex>
                                    { o.services.join(', ') }
                                    <br/><br/>
                                    <Divider/>
                                  </>
                                })}
                              </PopoverBody>
                            </PopoverContent>
                          </Popover>
                          })
                          : ''}
                        </Td>
                        {authUser.auth.role == 'manager'
                        ? <Td  p={2}>
                          {user.isDisabled 
                            ? <Text color={'red'}>disabled</Text>
                            : <Text color={'green'}>enabled</Text>}
                        </Td>
                        : null }
                        <Td  p={2}>
                        {authUser.auth.role == 'manager'
                          ? <Button p="0px" bg="transparent" onClick={() => selectEditItem(user.id)}>
                            <Flex color={textColor} cursor="pointer" align="center" p="12px">
                              <Icon as={FaPencilAlt} me="4px" />
                              <Text fontSize="xs" fontWeight="semibold">
                                EDIT
                              </Text>
                            </Flex>
                          </Button>
                          : null }

                          <Button p="0px" bg="transparent" onClick={() => selectHistoryItem(user.id)}>
                            <Flex color={textColor} cursor="pointer" align="center" p="12px">
                              <Icon as={FaList} me="4px" />
                              <Text fontSize="xs" fontWeight="semibold">
                                VIEW ORDERS
                              </Text>
                            </Flex>
                          </Button>
                        </Td>
                      </Tr>
                    );
                  })
                }
              </Tbody>
            </Table>
            
            <Pagination 
              totalItems={totalCustomers}
              pageRows={pageLimit}
              currentPage={page}
              onPageChanged={setPage}
            />
          </Flex>
        </CardBody>
      </Card>
     
    </Flex>

    {authUser.auth.role == 'manager'
    ? <CreateCustomer 
      isOpen={isOpenCreate}
      onClose={onCloseCreate}
      successCallback={reloadPage}
    />
    : null}
   
   {authUser.auth.role == 'manager'
    ? <EditCustomer
      isOpen={isOpenEdit}
      onClose={() => {
        setToEditUser(null);
        onCloseEdit();
      }}
      successCallback={reloadPage}
      userData={toEditUser}
    />
    : null}

    <OrderHistory
      isOpen={isOpenHistory}
      onClose={() => {
        setToEditUser(null);
        onCloseHistory();
      }}
      // successCallback={reloadPage}
      userData={toEditUser}
    />

    </>
  );
}

export default Customers;
